import Kendo from '../../../constants/kendo.constants';
import CoolantSample from './coolant-sample.grid.constants';
import Customer from './customer.grid.constants';
import OilSample from './oil-sample.grid.constants';
import Unit from './unit.grid.constants';

export default {
  CoolantSample,
  Customer,
  OilSample,
  Unit,
  default: {
    defaultColumns: [],
    gridData: [],
    isGlobalSearchActive: false,
    isLoading: false,
    isRequesting: false,
    isPageableThreshold: 10,
    items: [],
    pageable: {
      buttonCount: 3,
      info: true,
      type: Kendo.pagination.numeric,
      pageSizes: [5, 10, 15, 20, 25, 30],
      previousNext: true,
      messages: {
        display: '{0:#,##} - {1:#,##} of {2:#,##} items'
      }
    },
    pageSize: 25,
    params: {
      filter: {},
      globalSearch: {
        query: '',
        isActive: true
      },
      sort: {},
      pagination: {
        pageNumber: 1,
        pageSize: 10
      }
    },
    selectedColumns: [],
    serverTotal: 0,
    skip: 0,
    take: 10
  }
};
